<div class="banner">
  <div class="col-12">
    <h1>Reports</h1>
  </div>
</div>
<form #reportForm="ngForm">
  <div class="center">
    <iui-messages #message  class="ms-auto me-auto"></iui-messages>
  </div>
  <div class="tabcontent">
    <div class="row">
      <div class="col-12 mb-2">
        <h5>Download a Report</h5>
        <div class="row ms-0 ">Please select the report to download. The criteria for defining the report will change
          depending upon the selected report type. </div>
      </div>
    </div>
    <div class="row ">
      <div class="col-3 mb-3">
        <label for="reportType" class="required">Report Type</label>
        <p-dropdown appDd [options]="reportTypes" [required]="true" [(ngModel)]="selectedReportType" #reportType="ngModel" [filter]="true"
          (onChange)="changeReportType()" name="reportType" id="reportType"></p-dropdown>
      </div>
    </div>
    <div class="row" *ngIf="selectedReportType !== 'scList' && selectedReportType !== 'scBrand' && selectedReportType !== 'brandList' && selectedReportType !== 'contentProviderList'">
      <div class="col-3 mb-3">
        <label for="dateRanges" class="required">Date Range</label>
        <p-dropdown appDd [options]="filteredDateRange" [required]="true" [(ngModel)]="selectedDateRange" [filter]="true"
          #reportType="ngModel" name="dateRanges" id="dataRanges"></p-dropdown>
      </div>
    </div>
    <div class="row " *ngIf="selectedDateRange==='DateRange' ">
      <div class="col-3">
        <label for="startDate">
          Start
          <div>
            <p-calendar #ngServiceId="ngModel" id="startDates" placeholder="Start Date" [showIcon]="true"
              name="startDates" [(ngModel)]="startDate" [maxDate]="maxDate" dateFormat="yy-mm-dd" [maxDate]="today"></p-calendar>
          </div>
        </label>
      </div>
      <div class="col-3">
        <label for="endDate">End
          <div>
            <p-calendar placeholder="End Date" [showIcon]="true" name="endDate" inputId="endDate" [(ngModel)]="endDate"
              [maxDate]="maxDate" dateFormat="yy-mm-dd" [disabled]="!startDate"></p-calendar>
          </div>
        </label>
      </div>
    </div>

    <div class=" mb-4 mt-4"  *appNotAuthIf="[CognitoGroup.CarrierRegistrant, CognitoGroup.Carrier] ">
      <p-checkbox *ngIf="selectedReportType === 'paymentSummary'" label="Include unpaid invoices"
      [(ngModel)]="includeUnpaidInvoices" name="includeUnpaidInvoices"
      (onChange)="includeUnpaidInvoicesCheck($event)" [binary]="true" id="includeUnpaidInvoices">
  </p-checkbox>
</div>
    <div class=" mb-4 mt-4" *ngIf="selectedReportType === 'paymentSummary'">
      <p-radioButton name="prepay" id="retrievebysc" [(ngModel)]="retrieveby" value="ShortCode" label="Short Code"
        class="me-3"></p-radioButton>
      <p-radioButton name="prepay" id="retrievebyorder" [(ngModel)]="retrieveby" value="Order" label="Order ">
      </p-radioButton>
    </div>
    <div class="row ms-1 mt-2">
      <div class="col-4 ps-0">
        <button type="button" class="btn btn-primary" (click)="downloadReport(reportForm)">Download Report</button>
      </div>
    </div>
  </div>
</form>
